import PackageBase from "../../views/Package/PackageBase.vue";
import PackageInfo from "../../views/Package/PackageInfo.vue";
import PackageContributors from "../../views/Package/PackageContributors.vue";
import PackageVersions from "../../views/Package/PackageVersions.vue";
import PackageDependencies from "../../views/Package/PackageDependencies.vue";

export default {
  path: "/package/:name/:versionName",
  component: PackageBase,
  props: true,
  children: [
    {
      path: "",
      name: "package_version_info",
      component: PackageInfo
    },
    {
      path: "contributors",
      name: "package_version_contributors",
      props: true,
      component: PackageContributors
    },
    {
      path: "versions",
      name: "package_version_versions",
      props: true,
      component: PackageVersions
    },
    {
      path: "dependencies",
      name: "package_version_dependencies",
      props: true,
      component: PackageDependencies
    }
  ]
};
